// extracted by mini-css-extract-plugin
module.exports = {"dividerContainer":"color-picker_dividerContainer__36DDZ"};